export const HelpTerms = [
  {
    title: 'i18n.payments.paymentActivity.helpModal.pending.term',
    definition: 'i18n.payments.paymentActivity.helpModal.pending.definition',
    dataCy: 'pending-payment',
  },
  {
    title: 'i18n.payments.paymentActivity.helpModal.processing.term',
    definition: 'i18n.payments.paymentActivity.helpModal.processing.definition',
    dataCy: 'payment-processing',
  },
  {
    title: 'i18n.payments.paymentActivity.helpModal.cancelling.term',
    definition: 'i18n.payments.paymentActivity.helpModal.cancelling.definition',
    dataCy: 'cancelling-payment',
  },
  {
    title: 'i18n.payments.paymentActivity.helpModal.canceled.term',
    definition: 'i18n.payments.paymentActivity.helpModal.canceled.definition',
    dataCy: 'canceled-payment',
  },
  {
    title: 'i18n.payments.paymentActivity.helpModal.paid.term',
    definition: 'i18n.payments.paymentActivity.helpModal.paid.definition',
    dataCy: 'completed-payment',
  },
  {
    title: 'i18n.payments.paymentActivity.helpModal.reference-number.term',
    definition:
      'i18n.payments.paymentActivity.helpModal.reference-number.definition',
    dataCy: 'payment-reference-number',
  },
  {
    title: 'i18n.payments.paymentActivity.helpModal.payment-method.term',
    definition:
      'i18n.payments.paymentActivity.helpModal.payment-method.definition',
    dataCy: 'payment-method',
  },
];
